// OBSOLETE: CPR was replaced by FCR for invoices dated on or after 2026-11-30. Remove this page anytime after 2027-01-01.
import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import { AppActionCreators, IApplicationState, ReportActionCreators } from '@nkr/store/index';
import { ICprScoreResponse } from '@nkr/store/reports';
import { ScoresReport } from '../fcr-scores/scores-report';

interface IProps {
    allCenters: boolean
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getCprScores: (month: number, year: number) => Promise<ICprScoreResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

const CprScoresReport = (props: TProps) => {
    return (
        <ScoresReport
            allCenters={props.allCenters}
            title='Center Compatible Pair Ratio (CPR) Scores'
            showFcr={false}
            lookbackMonths={6}
            fileName='center-cpr-scores-using-data-last-12-months.csv'
            loadingMessage='Getting CPR scores, one moment please...'
            showLoading={props.showLoading}
            hideLoading={props.hideLoading}
            getScores={props.getCprScores}
        />
    );
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getCprScores: (month, year) => {
            return dispatch(ReportActionCreators.getCprScores(month, year));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(CprScoresReport);
